/* ============================================================================
   Gaucheria — sacola
   ----------------------------------------------------------------------------
   Cart AJAX API do Shopify: /cart/add.js, /cart/change.js, /cart.js

   Tudo aqui é melhoria progressiva. Sem este arquivo a loja continua vendendo:
   - o formulário de produto faz POST nativo para /cart/add;
   - o formulário da sacola faz POST nativo para /cart com os campos updates[chave];
   - o botão de remover é um link de verdade para item.url_to_remove.

   O CSS esconde o que só faz sentido com JavaScript (botões de mais e menos,
   botão "Atualizar sacola") a partir da classe .com-js posta no <html>.
   ============================================================================ */

(function ()
{
  'use strict';

  var ROTA_ADICIONAR = '/cart/add.js';
  var ROTA_ALTERAR = '/cart/change.js';
  /* update.js aceita varias variantes de uma vez; change.js so mexe numa linha. */
  var ROTA_ATUALIZAR = '/cart/update.js';
  var ROTA_SACOLA = '/cart.js';

  /* ------------------------------------------------------------------------
     Aviso — porte do Toast.jsx. Sucesso usa tinta, nunca verde.
     ------------------------------------------------------------------------ */
  var temporizadorAviso = null;

  function mostrarAviso(texto, tom)
  {
    var caixa = document.getElementById('aviso-sacola');
    if (!caixa) { return; }

    caixa.textContent = texto;
    caixa.setAttribute('data-visivel', 'true');

    if (tom === 'erro')
    {
      caixa.setAttribute('data-tom', 'erro');
    }
    else
    {
      caixa.removeAttribute('data-tom');
    }

    window.clearTimeout(temporizadorAviso);
    temporizadorAviso = window.setTimeout(function ()
    {
      caixa.removeAttribute('data-visivel');
      caixa.textContent = '';
    }, 4000);
  }

  /* ------------------------------------------------------------------------
     Textos. Ficam no DOM (data-texto-*) para continuarem vindo de locales/.
     ------------------------------------------------------------------------ */
  function texto(chave, padrao)
  {
    var raiz = document.querySelector('[data-textos-sacola]');
    if (raiz && raiz.getAttribute('data-' + chave))
    {
      return raiz.getAttribute('data-' + chave);
    }
    return padrao;
  }

  /* ------------------------------------------------------------------------
     Contador do cabeçalho
     ------------------------------------------------------------------------ */
  function atualizarContador(quantidade)
  {
    var alvos = document.querySelectorAll('[data-contador-sacola]');
    var i;

    for (i = 0; i < alvos.length; i = i + 1)
    {
      alvos[i].textContent = quantidade;
      if (quantidade > 0)
      {
        alvos[i].classList.remove('contador-sacola--vazio');
      }
      else
      {
        alvos[i].classList.add('contador-sacola--vazio');
      }
    }

    var textos = document.querySelectorAll('[data-contador-sacola-texto]');
    for (i = 0; i < textos.length; i = i + 1)
    {
      textos[i].textContent = quantidade + ' ' + texto('itens', 'itens na sacola');
    }
  }

  function sincronizarContador()
  {
    return fetch(ROTA_SACOLA, { headers: { Accept: 'application/json' } })
      .then(function (resposta) { return resposta.json(); })
      .then(function (sacola)
      {
        atualizarContador(sacola.item_count);
        return sacola;
      });
  }

  /* ------------------------------------------------------------------------
     Adicionar à sacola
     ------------------------------------------------------------------------ */
  function ligarFormularioProduto()
  {
    var formulario = document.querySelector('[data-form-sacola]');
    if (!formulario) { return; }

    formulario.addEventListener('submit', function (evento)
    {
      evento.preventDefault();

      var botao = formulario.querySelector('[data-botao-adicionar]');
      var erro = formulario.querySelector('[data-erro-sacola]');

      if (erro)
      {
        erro.hidden = true;
        erro.textContent = '';
      }

      if (botao) { botao.disabled = true; }

      fetch(ROTA_ADICIONAR, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(formulario)
      })
        .then(function (resposta)
        {
          return resposta.json().then(function (corpo)
          {
            return { ok: resposta.ok, corpo: corpo };
          });
        })
        .then(function (resultado)
        {
          if (!resultado.ok)
          {
            var mensagem = resultado.corpo.description || resultado.corpo.message
              || texto('erro', 'Não deu pra guardar na sacola agora.');

            if (erro)
            {
              erro.textContent = mensagem;
              erro.hidden = false;
            }
            mostrarAviso(mensagem, 'erro');
            return null;
          }

          mostrarAviso(texto('adicionado', 'Bah, guardamos na tua sacola.'), 'sucesso');
          return sincronizarContador();
        })
        .catch(function ()
        {
          mostrarAviso(texto('erro', 'Não deu pra guardar na sacola agora.'), 'erro');
        })
        .then(function ()
        {
          if (botao) { botao.disabled = false; }
        });
    });
  }

  /* ------------------------------------------------------------------------
     Grade de atacado

     A função de pedido mínimo é avaliada pela Shopify a cada mexida no
     carrinho, então somar tamanho por tamanho devolve 422 em todo acréscimo
     parcial. Aqui a grade inteira vai numa requisição só: o carrinho pula de
     zero para o pedido fechado, e a validação vê um carrinho completo.
     ------------------------------------------------------------------------ */
  function somarGrade(grade)
  {
    var total = 0;

    grade.querySelectorAll('tbody tr').forEach(function (linha)
    {
      var subtotal = 0;

      linha.querySelectorAll('[data-grade-campo]').forEach(function (campo)
      {
        var valor = parseInt(campo.value, 10);
        if (!isNaN(valor) && valor > 0) { subtotal += valor; }
      });

      var celula = linha.querySelector('[data-grade-subtotal]');
      if (celula) { celula.textContent = String(subtotal); }

      total += subtotal;
    });

    return total;
  }

  function atualizarGrade(grade)
  {
    var minimo = parseInt(grade.getAttribute('data-minimo'), 10) || 0;
    var total = somarGrade(grade);
    var resumo = grade.querySelector('[data-grade-resumo]');
    var botao = grade.querySelector('[data-grade-adicionar]');
    /* Grade vazia nunca fecha. Com o mínimo padrão isso já era verdade, mas
       empresa com mínimo 0 (metafield custom.pedido_minimo_estampa) fechava
       com zero peça: "0 peças. Pode mandar." e o botão ligado sem nada. */
    var fecha = total > 0 && total >= minimo;

    if (resumo && total === 0 && minimo === 0)
    {
      /* Sem mínimo e sem peça, não há o que contar ainda. */
      resumo.textContent = '';
      resumo.removeAttribute('data-fecha');
    }
    else if (resumo)
    {
      /* Uma peça só não é "Faltam 1 peças". Concordância à mão, porque o
         Liquid interpola no servidor e este texto muda a cada digitada. */
      var numero = fecha ? total : minimo - total;
      var molde;

      if (fecha)
      {
        molde = numero === 1
          ? texto('grade_pronto_uma', '1 peça. Pode mandar.')
          : texto('grade_pronto', '[n] peças. Pode mandar.');
      }
      else
      {
        molde = numero === 1
          ? texto('grade_falta_uma', 'Falta 1 peça')
          : texto('grade_faltam', 'Faltam [n] peças');
      }

      resumo.textContent = molde.replace('[n]', String(numero));
      resumo.setAttribute('data-fecha', fecha ? 'true' : 'false');
    }

    if (botao) { botao.disabled = !fecha; }

    return total;
  }

  function enviarGrade(grade)
  {
    var itens = [];

    grade.querySelectorAll('[data-grade-campo]').forEach(function (campo)
    {
      var quantidade = parseInt(campo.value, 10);
      if (isNaN(quantidade) || quantidade < 1) { return; }

      itens.push({
        id: parseInt(campo.getAttribute('data-variante'), 10),
        quantity: quantidade
      });
    });

    if (itens.length === 0) { return Promise.resolve(); }

    var botao = grade.querySelector('[data-grade-adicionar]');
    var erro = grade.querySelector('[data-erro-sacola]');

    if (erro)
    {
      erro.hidden = true;
      erro.textContent = '';
    }
    if (botao) { botao.disabled = true; }

    return fetch(ROTA_ADICIONAR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: itens })
    })
      .then(function (resposta)
      {
        return resposta.json().then(function (corpo)
        {
          return { ok: resposta.ok, corpo: corpo };
        });
      })
      .then(function (resultado)
      {
        if (!resultado.ok)
        {
          /* A mensagem da função de validação vem no corpo da resposta.
             Mostrar ela, e não um texto genérico: ela diz o que falta. */
          var mensagem = resultado.corpo.description || resultado.corpo.message
            || texto('erro', 'Não deu pra guardar na sacola agora.');

          if (erro)
          {
            erro.textContent = mensagem;
            erro.hidden = false;
          }
          mostrarAviso(mensagem, 'erro');
          return null;
        }

        grade.querySelectorAll('[data-grade-campo]').forEach(function (campo)
        {
          campo.value = '0';
        });

        mostrarAviso(texto('adicionado', 'Bah, guardamos na tua sacola.'), 'sucesso');
        return sincronizarContador();
      })
      .catch(function ()
      {
        mostrarAviso(texto('erro', 'Não deu pra guardar na sacola agora.'), 'erro');
      })
      .then(function ()
      {
        atualizarGrade(grade);
      });
  }

  function ligarGrade()
  {
    var grade = document.querySelector('[data-grade-atacado]');
    if (!grade) { return; }

    atualizarGrade(grade);

    grade.addEventListener('input', function (evento)
    {
      if (evento.target.matches('[data-grade-campo]')) { atualizarGrade(grade); }
    });

    grade.addEventListener('click', function (evento)
    {
      var botao = evento.target.closest('[data-grade-adicionar]');
      if (botao) { enviarGrade(grade); }
    });
  }

  /* ------------------------------------------------------------------------
     Página da sacola
     ------------------------------------------------------------------------ */
  function recarregarSacola()
  {
    var secao = document.querySelector('[data-secao-sacola]');
    if (!secao) { return Promise.resolve(); }

    return fetch(window.location.pathname + '?section_id=carrinho-principal')
      .then(function (resposta) { return resposta.text(); })
      .then(function (html)
      {
        var casulo = document.createElement('div');
        casulo.innerHTML = html;

        var nova = casulo.querySelector('[data-secao-sacola]');
        if (nova)
        {
          secao.innerHTML = nova.innerHTML;
          document.dispatchEvent(new CustomEvent('sacola:redesenhada'));
        }
        return sincronizarContador();
      });
  }

  function alterarLinha(chave, quantidade, linha)
  {
    if (linha) { linha.setAttribute('data-processando', 'true'); }

    return fetch(ROTA_ALTERAR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: chave, quantity: quantidade })
    })
      .then(function (resposta)
      {
        if (resposta.ok) { return recarregarSacola(); }

        /* Recusa da função de pedido mínimo chega aqui: o lojista tentou baixar
           a estampa para menos que a grade. A resposta traz o motivo — mostrar
           ele, em vez do erro genérico, senão parece defeito da loja. */
        return resposta.json()
          .then(function (corpo)
          {
            return corpo.description || corpo.message || '';
          })
          .catch(function () { return ''; })
          .then(function (motivo)
          {
            if (linha) { linha.removeAttribute('data-processando'); }
            mostrarAviso(motivo || texto('grade_recusado', texto('erro_sacola', 'Não deu pra atualizar a sacola agora.')), 'erro');
            return recarregarSacola();
          });
      })
      .catch(function ()
      {
        if (linha) { linha.removeAttribute('data-processando'); }
        mostrarAviso(texto('erro_sacola', 'Não deu pra atualizar a sacola agora.'), 'erro');
      });
  }

  /* ------------------------------------------------------------------------
     Sacola do lojista, por estampa

     Editar célula por célula não serve: trocar 3 P por 4 P passaria por um
     estado em que a estampa fica abaixo da grade, e a função recusa. Aqui o
     cartão inteiro vai numa requisição só, em /cart/update.js.
     ------------------------------------------------------------------------ */
  function atualizarCartaoEstampa(cartao)
  {
    var minimo = parseInt(cartao.getAttribute('data-minimo'), 10) || 0;
    var total = somarGrade(cartao);
    var resumo = cartao.querySelector('[data-grade-resumo]');
    var botao = cartao.querySelector('[data-atualizar-estampa]');

    /* Zero é válido: significa tirar a estampa do pedido. */
    var valido = total === 0 || total >= minimo;

    if (resumo)
    {
      if (valido)
      {
        resumo.textContent = '';
        resumo.removeAttribute('data-fecha');
      }
      else
      {
        var faltam = minimo - total;
        resumo.textContent = faltam === 1
          ? texto('grade_falta_uma', 'Falta 1 peça')
          : texto('grade_faltam', 'Faltam [n] peças').replace('[n]', String(faltam));
        resumo.setAttribute('data-fecha', 'false');
      }
    }

    if (botao) { botao.disabled = !valido; }
  }

  function enviarCartaoEstampa(cartao, zerar)
  {
    var atualizacoes = {};

    cartao.querySelectorAll('[data-grade-campo]').forEach(function (campo)
    {
      var quantidade = zerar ? 0 : parseInt(campo.value, 10);
      if (isNaN(quantidade) || quantidade < 0) { quantidade = 0; }

      atualizacoes[campo.getAttribute('data-variante')] = quantidade;
    });

    cartao.setAttribute('data-processando', 'true');

    return fetch(ROTA_ATUALIZAR, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: atualizacoes })
    })
      .then(function (resposta)
      {
        if (resposta.ok) { return recarregarSacola(); }

        return resposta.json()
          .then(function (corpo) { return corpo.description || corpo.message || ''; })
          .catch(function () { return ''; })
          .then(function (motivo)
          {
            cartao.removeAttribute('data-processando');
            mostrarAviso(motivo || texto('grade_recusado', texto('erro_sacola', 'Não deu pra atualizar a sacola agora.')), 'erro');
            return recarregarSacola();
          });
      })
      .catch(function ()
      {
        cartao.removeAttribute('data-processando');
        mostrarAviso(texto('erro_sacola', 'Não deu pra atualizar a sacola agora.'), 'erro');
      });
  }

  function ligarSacolaEstampas()
  {
    function recalcularTodos()
    {
      document.querySelectorAll('[data-sacola-estampa]').forEach(atualizarCartaoEstampa);
    }

    /* Delegado no documento: a seção da sacola é redesenhada a cada alteração,
       e listener preso ao elemento morreria junto. */
    document.addEventListener('input', function (evento)
    {
      var cartao = evento.target.closest('[data-sacola-estampa]');
      if (cartao && evento.target.matches('[data-grade-campo]'))
      {
        atualizarCartaoEstampa(cartao);
      }
    });

    document.addEventListener('click', function (evento)
    {
      var cartao = evento.target.closest('[data-sacola-estampa]');
      if (!cartao) { return; }

      if (evento.target.closest('[data-atualizar-estampa]'))
      {
        evento.preventDefault();
        enviarCartaoEstampa(cartao, false).then(recalcularTodos);
        return;
      }

      if (evento.target.closest('[data-remover-estampa]'))
      {
        evento.preventDefault();
        enviarCartaoEstampa(cartao, true).then(recalcularTodos);
      }
    });

    recalcularTodos();

    /* Depois de cada redesenho da sacola os campos voltam ao valor gravado:
       recalcular para o botão nascer no estado certo. */
    document.addEventListener('sacola:redesenhada', recalcularTodos);
  }

  function ligarSacola()
  {
    document.addEventListener('click', function (evento)
    {
      var passo = evento.target.closest ? evento.target.closest('[data-passo]') : null;
      var remover = evento.target.closest ? evento.target.closest('[data-remover-linha]') : null;

      if (passo)
      {
        var contador = passo.closest('.contador-quantidade');
        if (!contador) { return; }

        var campo = contador.querySelector('[data-campo-quantidade]');
        if (!campo) { return; }

        var minimo = parseInt(campo.getAttribute('min') || '0', 10);
        var atual = parseInt(campo.value || '0', 10);
        var proximo = atual + parseInt(passo.getAttribute('data-passo'), 10);

        if (proximo < minimo) { proximo = minimo; }
        campo.value = proximo;

        var linha = passo.closest('[data-linha-sacola]');
        if (linha)
        {
          evento.preventDefault();
          alterarLinha(linha.getAttribute('data-chave'), proximo, linha);
        }
        return;
      }

      if (remover)
      {
        var linhaRemover = remover.closest('[data-linha-sacola]');
        if (linhaRemover)
        {
          evento.preventDefault();
          alterarLinha(linhaRemover.getAttribute('data-chave'), 0, linhaRemover);
        }
      }
    });

    document.addEventListener('change', function (evento)
    {
      var campo = evento.target.closest ? evento.target.closest('[data-campo-quantidade]') : null;
      if (!campo) { return; }

      var linha = campo.closest('[data-linha-sacola]');
      if (!linha) { return; }

      var quantidade = parseInt(campo.value || '0', 10);
      if (isNaN(quantidade) || quantidade < 0) { quantidade = 0; }

      alterarLinha(linha.getAttribute('data-chave'), quantidade, linha);
    });
  }

  function iniciar()
  {
    ligarFormularioProduto();
    ligarGrade();
    ligarSacolaEstampas();
    ligarSacola();
  }

  if (document.readyState === 'loading')
  {
    document.addEventListener('DOMContentLoaded', iniciar);
  }
  else
  {
    iniciar();
  }
}());
